import Modal from "@/components/Modal";
import { InlineError } from "@/components/InlineError";
import { AlertTriangle, CheckCircle2, Loader2 } from "lucide-react";

export default function ConfirmDialog({ open, title, message, confirmLabel, danger = true, loading = false, error, onConfirm, onClose }) {
  const heading = title || (danger ? "Confirmer la suppression" : "Confirmer l'action");
  const label = confirmLabel || (danger ? "Supprimer définitivement" : "Valider");
  const Icon = danger ? AlertTriangle : CheckCircle2;
  return (
    <Modal open={open} onClose={onClose} title={heading} testId="confirm-dialog" zClass="z-[60]"
      footer={<>
        <button className="btn-outline" onClick={onClose} disabled={loading} data-testid="confirm-cancel-btn">Annuler</button>
        <button className={danger ? "btn-danger" : "btn-primary"} onClick={onConfirm} disabled={loading} data-testid="confirm-ok-btn">
          {loading && <Loader2 className="w-4 h-4 animate-spin" />}{label}
        </button>
      </>}>
      <div className="flex items-start gap-3">
        <div className={`w-10 h-10 rounded-xl flex items-center justify-center shrink-0 ${danger ? "bg-[#FEE2E2] text-[#B91C1C]" : "bg-[#EFF6FF] text-[#2563EB]"}`}>
          <Icon className="w-5 h-5" />
        </div>
        <p className="text-sm text-[#475569] leading-relaxed pt-1.5">{message}</p>
      </div>
      <InlineError message={error} />
    </Modal>
  );
}
